import React, { ChangeEvent, FormEvent, useCallback, useEffect, useState } from 'react'
import { RelationsType } from "../../../api/projects-api"
import { AttachedItem } from './AttachedItem'


type AttachedListPropsType = {
  relations: Array<RelationsType>
  projectId: number
  projectName: string
  taskId: number

}

export const AttachedItemsList = React.memo((props: AttachedListPropsType) => {
  console.log('attached list')

  return (
    <>
     {props.relations?.map((file) => (
            <AttachedItem  projectName={props.projectName} taskId={props.taskId} projectId={props.projectId} file={file} />
          ))}
    </>
  )
})